export default __webpack_public_path__ + "static/media/sc-mail-ico.99547c79.svg";